import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { C3BoothFilter, C3ConcernedPerson, DateFilter } from "./filters";
import { FormButtons, SideOverlay } from "../../components";
import { useLocation } from "react-router-dom";
import { useStore } from "../../helpers";
import dayjs from "dayjs";
import { RepresentativeFilter } from "../../components/cm-filters/representative-filter";
import { safe_get } from "../../report-visuals";
import { ServiceRequestFilter } from "./serviceRequestFilter";

type c3FilterType = {
  piv_level_2: string[];
  start_date: string;
  end_date: string;
  office_persons: string[];
  rep?: string[];
};

const defaultC3Filters: c3FilterType = {
  piv_level_2: [],
  start_date: "",
  end_date: "",
  office_persons: [],
  rep: [],
};

type servicerequestFilter = {
  key?: string;
  request_type?: string[];
  priority?: string[];
  location?: string[];
  status?: string[];
  assigned?: string[];
};

const defaultserviceFilters: servicerequestFilter = {
  key: "",
  request_type: [],
  priority: [],
  location: [],
  status: [],
  assigned: [],
};

export const C3Filters = observer(() => {
  const rootStore = useStore();
  const { c3Store, projectStore, beneficiaryStore } = rootStore;
  const { pathname } = useLocation();

  const [loading, setLoading] = useState(false);

  const [beneficiarySelectedFilters, setBeneficiarySelectedFilters] =
    useState(beneficiaryStore.filters);

  const beneficiery_property = projectStore.getProjectProperty(
    "beneficiary",
    {}
  );

  const representativeOptions = safe_get(
    beneficiery_property,
    "more.representatives",
    []
  );

  const [c3Filters, setC3Filters] = useState<c3FilterType>(defaultC3Filters);

  const [serviceFilter, setServiceFilter] =
    useState<servicerequestFilter>(
      c3Store.servicerequestFilter
    );

  const showDateSlider =
    pathname.includes("beneficiaries") || pathname.includes("grievance");

  const showservicereq = pathname.includes("service_request");

  const onBoothSelection = (booths: string[]) => {
    setC3Filters((prev) => ({ ...prev, piv_level_2: booths }));
  };

  const onPersonSelection = (persons: string[]) => {
    setC3Filters((prev) => ({ ...prev, office_persons: persons }));
  };

  const onDateSelection = (
    start_date: string,
    end_date: string = dayjs().format("YYYY-MM-DD")
  ) => {
    setC3Filters((prev) => ({
      ...prev,
      start_date,
      end_date,
    }));
  };

  const filter_save_handler = () => {
    setLoading(true);

    c3Store.update_selected_booths(c3Filters.piv_level_2);
    c3Store.update_date_filters(
      c3Filters.start_date,
      c3Filters.end_date
    );
    c3Store.update_selected_office_persons(
      c3Filters.office_persons
    );
    c3Store.update_rep(c3Filters.rep);

    c3Store.setServicerequestFilter({
      ...serviceFilter,
      piv_level_2: c3Filters.piv_level_2,
    });

    c3Store.update_c3FilterModal(false);
    setLoading(false);
  };

  const filter_cancel_handler = () => {
    c3Store.update_c3FilterModal(false);

    c3Store.setServicerequestFilter({
      ...defaultserviceFilters,
      piv_level_2: [],
    });

    setServiceFilter({ ...defaultserviceFilters });
    setC3Filters({ ...defaultC3Filters });
    c3Store.update_selected_booths([]);
  };
  return (
    <SideOverlay
      title="Select Filters"
      onClose={filter_cancel_handler}
      show={c3Store.c3FiltersModal}
    >
      <div className="flex flex-col h-full">
        <div className="flex-1 overflow-y-auto px-3 py-2">
          {showservicereq && <ServiceRequestFilter />}

          {!showservicereq && (
            <div className="bg-gray-100 rounded-lg flex flex-col gap-6 p-3 pb-10">

              <div className="custom-dropdown">
                <p className="text-blue-600 font-bold text-xl">
                  Booth Filters
                </p>
                <C3BoothFilter
                  onBoothSelection={onBoothSelection}
                />
              </div>

              <div className="custom-dropdown">
                <p className="text-blue-600 font-bold text-xl">
                  Concerned Office Person
                </p>
                <C3ConcernedPerson
                  onPersonSelection={onPersonSelection}
                />
              </div>

              {representativeOptions.length > 0 && (
                <div className="custom-dropdown">
                  <p className="text-blue-600 font-bold text-xl">
                    Representative Type
                  </p>
                  <RepresentativeFilter
                    onPersonSelection={(val) =>
                      setBeneficiarySelectedFilters({
                        ...beneficiarySelectedFilters,
                        rep: val,
                      })
                    }
                  />
                </div>
              )}

              {showDateSlider && (
                <div>
                  <p className="text-blue-600 font-bold text-xl">
                    Date
                  </p>
                  <DateFilter
                    onDateChange={onDateSelection}
                    startDate={c3Filters.start_date}
                    endDate={c3Filters.end_date}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {!showservicereq && (
          <div className="sticky bottom-0 bg-white border-t z-20">
            <FormButtons
              onSave={filter_save_handler}
              onCancel={filter_cancel_handler}
            />
          </div>
        )}
      </div>
    </SideOverlay>
  );
});
